import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { ArrowLeft, ListChecks } from "lucide-react";
import CustomInvoiceBuilder from "../../components/vendor/invoice/CustomInvoiceBuilder";
import {
  VendorPageHeader,
  VendorGuideCallout,
} from "../../components/vendor/guidance";
import { VENDOR_PAGE_GUIDES } from "../../utils/vendorPageGuides";
import ChannelBadge from "../../components/shared/ChannelBadge";

const VendorInvoiceCreate = () => {
  const [searchParams] = useSearchParams();
  const channel =
    searchParams.get("channel") === "internal" ? "internal" : "external";
  const isExternal = channel === "external";
  const backTo = isExternal ? "/vendor/invoices" : "/vendor/internal-invoices";

  return (
    <div className="space-y-5">
      <div>
        <Link
          to={backTo}
          className="mb-4 inline-flex items-center gap-2 text-sm text-ink-secondary hover:text-gray-900"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to {isExternal ? "External" : "Internal"} invoices
        </Link>
        <VendorPageHeader
          title="Custom invoice"
          subtitle={
            isExternal
              ? "Bill a guest or off-platform client — outside marketplace accounting."
              : "Bill a platform client from a marketplace relationship."
          }
          actions={<ChannelBadge channel={channel} />}
        />
      </div>
      <VendorGuideCallout
        title={VENDOR_PAGE_GUIDES.invoiceCreate.title}
        steps={VENDOR_PAGE_GUIDES.invoiceCreate.steps}
        icon={ListChecks}
      />
      <CustomInvoiceBuilder lockedChannel={channel} />
    </div>
  );
};

export default VendorInvoiceCreate;
